import { Breadcrumb, Card, Row, Layout, Col } from 'antd'
import { useState, useEffect } from 'react'
import { Link, useRouteMatch, useLocation } from 'react-router-dom'
import CreateMacroForm from './CreateMacroForm'
import './index.scss'
import { load } from 'Components/Macro/helpers'

Macros = ->
  { params: { spaceId, formId }} = useRouteMatch()
  { search } = useLocation()
  [loading, setLoading] = useState(true)
  [initialState, setInitialState] = useState(undefined)

  useEffect( ->
    (->
      if formId isnt 'new'
        setInitialState(await load(formId))
      setLoading(false)
    )()
    undefined
  , [])

  <Layout className="macros-container">
    <Breadcrumb style={{ margin: 20, marginBottom: 0 }}>
      <Breadcrumb.Item>
        { Weaver.getInstance().currentProject().name() }
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to="/#{ spaceId }/settings/forms">
          Forms
        </Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        { formId }
      </Breadcrumb.Item>
    </Breadcrumb>
    <Row style={{ flex: 1 }} justify="center" align="middle">
      <Col flex={0.6}>
        <Card
          loading={loading}
          className="create-macro-container"
          bordered={false}
        >
          { 
            <CreateMacroForm state={initialState}/>
          }
        </Card>
      </Col>
    </Row>
  </Layout>

export default Macros
